// src/theme.ts
import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    navy: {
      900: "#182638", // Blue 40
      800: "#283B5A", // Blue 30 (current hero/nav)
      700: "#46627C", // Blue 20
    },
    blue: {
      50: "#CADFED", // Blue 10 background
    },
    orange: {
      500: "#DB5C2C", // Orange 30
    },
    gold: {
      400: "#FBB15F", // Gold 20
    },
    gray: {
      700: "#686C6D",
    },
    red: {
      600: "#BE2034",
    },
    green: {
      600: "#71A37A",
    },
  },
  fonts: {
    heading:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
    body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
  },
});

export default theme;
